// this is a near replica of vfg-field-custom-richtext.vue.  We should investigate
// consolidating the code, but left it as is.  This gives us two versions of
// rich text, one inside the vue form generator and another that is just a vanilla vue component
<template>
<div id="wrapper">
  <editor-menu-bar id="menuBar" :editor="editor" v-slot="{ commands, isActive, focused }">
      <div
        class="menubar is-hidden m-0"
        :class="{ 'is-focused': focused }"
      >
        <b-button
          :class="{ 'is-active': isActive.bold() }"
          @click="commands.bold"
          id="button"
        >
        <font-awesome-icon icon="bold" fixed-width />
        </b-button>
        <button
          :class="{ 'is-active': isActive.italic() }"
          @click="commands.italic"
          id="button"
        >
          <font-awesome-icon icon="italic" fixed-width />
        </button>
        <button
          :class="{ 'is-active': isActive.strike() }"
          @click="commands.strike"
          id="button"
        >
          <font-awesome-icon icon="strikethrough" fixed-width />
        </button>
        <button
          :class="{ 'is-active': isActive.underline() }"
          @click="commands.underline"
          id="button"
        >
          <font-awesome-icon icon="underline" fixed-width />
        </button>
        <button
          :class="{ 'is-active': isActive.bullet_list() }"
          @click="commands.bullet_list"
          id="button"
        >
          <font-awesome-icon icon="list" fixed-width />
        </button>
        <button
          :class="{ 'is-active': isActive.ordered_list() }"
          @click="commands.ordered_list"
          id="button"
        >
          <font-awesome-icon icon="list-ol" fixed-width />
        </button>
      </div>
    </editor-menu-bar>
  <div id="textbox">
    <editor-content id="clickbox" :editor="editor" />
  </div>
</div>
</template>

<script>
// Import the editor
import { Editor, EditorContent, EditorMenuBar } from 'tiptap';
import MaxSize from '@/formGeneratorExtensions/maxSize';

import {
  Blockquote,
  BulletList,
  CodeBlock,
  HardBreak,
  Heading,
  ListItem,
  OrderedList,
  TodoItem,
  TodoList,
  Bold,
  Code,
  Italic,
  Link,
  Strike,
  Underline,
  History,
} from 'tiptap-extensions';

export default {
  name: 'RichTextEditor',
  components: {
    EditorContent,
    EditorMenuBar,
  },
  props: ['value', 'maxSizeLimit'],
  data() {
    return {
      editor: null,
      data: '',
    };
  },
  mounted() {
    this.editor = new Editor({
      extensions: [
        new Blockquote(),
        new BulletList(),
        new CodeBlock(),
        new HardBreak(),
        new Heading({ levels: [1, 2, 3] }),
        new ListItem(),
        new OrderedList(),
        new TodoItem(),
        new TodoList(),
        new Link(),
        new Bold(),
        new Code(),
        new Italic(),
        new Strike(),
        new Underline(),
        new History(),
        new MaxSize({ maxSize: this.maxSizeLimit }),

      ],
      content: this.value,
      onUpdate: ({ getHTML }) => {
        this.value = getHTML();
        this.$emit('input', getHTML());
      },
    });
  },
  beforeDestroy() {
    if (this.editor) {
      this.editor.destroy();
    }
  },
};
</script>

<style lang="scss" scoped>
  #textbox{
    display: block;
    padding: 6px 12px;
    line-height: 1.42857143;
    color: #555;
    background-color: #fff;
    background-image: none;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
    transition: border-color .15s ease-in-out,
    box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
    width: 100%;
    height: 100%;
  }
  #clickbox{
    height: 100%;
    width: 100%;
  }
  #wrapper{
    margin-bottom: 5%;
    width: 100%;
  }
  #button{
    border: none;
    padding: 6px 12px;
    background-color: #fff;
    color: #333;
  }
</style>
